import { RouteConfig } from 'vue-router'

const Index = () => import('../activity/fight-square-soldier2/Index.vue')

export const indexRoute: RouteConfig = {
  path: '/activity/fight-square-soldier2',
  name: 'activity_fight_square-soldier2',
  component: Index,
  props: (route) => ({ ...route.query, ...route.params }),
  meta: {
    title: '敏捷火枪手之特工集结',
  },
}

export default [indexRoute]
